import { Container } from "@mui/material";
import React from "react";
import useStyles from "../../styles/styles";
import Header from "./Header";
// import Navbar from "react-bootstrap/Navbar";
// import { loginRequest } from "../authConfig";
// import { useIsAuthenticated, useMsal } from "@azure/msal-react";
// import { SignInButton } from "./SignInButton";
// import { SignOutButton } from "./SignOutButton";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = ({ children, showlayout = false }) => {
  useStyles();
  // const isAuthenticated = useIsAuthenticated();

  // if (isAuthenticated) {
  //   return (
  //     <>
  //       <Navbar bg="primary" variant="light">
  //         <h3 className="navbar-brand">Microsoft Identity Platform</h3>
  //         <SignOutButton />
  //       </Navbar>
  //       <br />

  //       {props.children}
  //     </>
  //   );
  // }

  if (showlayout) {
    return (
      <>
        {/* <LayoutStoreProvider> */}
        <Header />
        <Container maxWidth="xl">
          {children}
          {/* <Footer /> */}
        </Container>
        {/* </LayoutStoreProvider> */}
      </>
    );
  } else {
    // return <LayoutStoreProvider>{children}</LayoutStoreProvider>;
    return children;
  }
  // return (
  //   <>
  //     {/* <Navbar bg="primary" variant="dark">
  //       <h3 className="navbar-brand">Microsoft Identity Platform</h3>
  //     </Navbar> */}
  //     <h5>
  //       <center>
  //         Welcome to the Microsoft Authentication Library For Javascript - React
  //         Quickstart
  //       </center>
  //     </h5>
  //     <br />
  //     <br />
  //     {children}
  //     <center>{/* <SignInButton /> */}</center>
  //   </>
  // );
};
